import styled from "styled-components";

export const ActivityFormCusPreviewContainerStyled = styled.div`
  padding: 20px 0px 0px 0px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .header_back_home_layout {
    display: none;
  }
  .body_layout {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    padding: 0px 20px 40px 20px;
    .title_page {
      margin-bottom: 16px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S19};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .header_question_layout {
      margin-bottom: 28px;
      border-radius: 10px;
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      overflow: hidden;
      .title {
        padding: 12px 12px;
        background: ${({ theme }) => theme.COLORS.PURPLE_1};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S15};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      }
      .desc {
        padding: 14px 12px;
        color: ${({ theme }) => theme.COLORS.BLACK_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S13};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      }
    }
    .quiz_container_layout {
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    }
    .pdpa_title {
      margin-bottom: 4px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_BOLD};
    }
    .pdpa_sub_title {
      margin-bottom: 12px;
      color: ${({ theme }) => theme.COLORS.BLACK_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
    .f_action_layout {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      column-gap: 8px;
      .action_item_wrap {
        flex-basis: 50%;
      }
    }
    .btn_send_form {
      margin: auto;
      margin-top: 30px;
      max-width: 294px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 0px;
    .breadcrumb_layout {
      display: none;
    }
    .header_back_home_layout {
      display: block;
    }
    .body_layout {
      padding: 32px 20px 40px 20px;
      .btn_send_form {
        max-width: 200px;
      }
    }
  }
`;
